<template>
  <VDataTable
    :headers="headers"
    :items="items"
    no-data-text="Keine Daten verfügbar"
    hide-default-footer
  >
    <template #body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.data"
        >
          <td class="cell no-padding text-right">
            {{ item.date }}
          </td>
          <td class="cell no-padding text-left">
            {{ item.orderName }}
          </td>
          <td class="cell no-padding text-left">
            {{ item.address }}
          </td>
          <td class="cell no-padding text-right">
            {{ item.start }}
          </td>
          <td class="cell no-padding text-right">
            {{ item.end }}
          </td>
        </tr>
      </tbody>
    </template>
  </VDataTable>
</template>

<script>
  export default {
    data: () => ({
      items: [],
      headers: [
        {
          text: "Datum",
          align: "right",
          value: "date"
        },
        {
          text: "Auftrag",
          align: "left",
          value: "orderName"
        },
        {
          text: "Adresse",
          align: "left",
          value: "address"
        },
        {
          text: "Start",
          align: "right",
          value: "start"
        },
        {
          text: "Ende",
          align: "right",
          value: "end"
        }
      ]
    })
  };
</script>
